import { useEffect, useState } from 'react';

// Styling
import styles from '../../../pages/Badging/StaticFieldManager/StaticFieldManager.module.css'

// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

// image elements
const circleCheck = <FontAwesomeIcon icon={faCircleCheck} />
const circleXmark = <FontAwesomeIcon icon={faCircleXmark} />

// ------ Components ------ //

const StaticField = ({
    index,
    item,
    updateCompiledObject,
    updateDataValidationObject,
}) => {
   // console.log("item", item)

    // Constants
    const options = item.availableSelections && item.availableSelections !== undefined && item.availableSelections.length > 0 ? item.availableSelections : []

    // State
    const [validData, setValidData] = useState(false)
    const [selectedOption, setSelectedOption] = useState(options[0] || '')
    const [textValues, setTextValues] = useState(() => {
        const initialValues = {}
        // Save sends TextValues back positionally (index 0 -> StaticField01, index 9 -> StaticField10),
        // so entries must be sorted by cssField here - the API doesn't guarantee that order.
        const sortedFields = [...item.extraBadgeStaticFields].sort((a, b) => a.cssField - b.cssField)
        options.forEach(option => {
            const name = option.toLowerCase()
            sortedFields.forEach(entry => {
                if (entry.fieldValueSelected && entry.fieldValueSelected.toLowerCase() === name) {
                    if (initialValues[option] === undefined) {
                        // create an array, if not already present
                        initialValues[option] = [];
                    }
                    // textValue can be null from the API; keep the array all-strings so
                    // handleValidData's .trim() and the controlled <input> don't blow up on it.
                    initialValues[option].push(entry.textValue ?? '');
                }
                else {
                    if (initialValues[option] === undefined) {
                        // create an array, if not already present
                        initialValues[option] = [];
                    }
                    // textValue can be null from the API; keep the array all-strings so
                    // handleValidData's .trim() and the controlled <input> don't blow up on it.
                    initialValues[option].push('');
                }
            })
        })
        return initialValues
    })

    const handleSelectChange = e => {
        const newOption = e.target.value
        setSelectedOption(newOption)
        if (!textValues[newOption]) {
            setTextValues(prevValues => ({
                ...prevValues,
                [newOption]: ['', '', '', '', '', '', '', '', '', ''],
            }))
        }
    }

    const handleTextChange = (e, index) => {
        const newValue = e.target.value
        setTextValues(prevValues => ({
            ...prevValues,
            [selectedOption]: prevValues[selectedOption].map((val, idx) => idx === index ? newValue : val)
        }))
    }

    const handleValidData = (obj) => {
        return Object.values(obj).every(array => array.some(item => item.trim() !== ""))
    }

    useEffect(() => {
        const handleTextValuesChange = async () => {
            updateCompiledObject(index, textValues)
        }

        const validityCheck = async () => {
            const validBool = await handleValidData(textValues)
            setValidData(validBool)
            updateDataValidationObject(index, validBool)
        }

        handleTextValuesChange()
        validityCheck()
    }, [textValues])

    return (
        <tr key={index} className={styles.SFTableRow}>
            <td className={styles.tableData}>
                {
                    item.badgeName
                        ? item.badgeName
                        : item.cssExtraBadgesFieldName
                            ? item.cssExtraBadgesFieldName
                            : ""
                }
            </td>
            <td className={styles.tableData}>
                <select value={selectedOption} onChange={handleSelectChange}>
                    <option disabled={true} value="">
                        -- Select an option --
                    </option>
                    {
                        item.availableSelections.map((selection, idx) => (
                            <option key={idx} value={selection}>{selection}</option>
                        ))
                    }
                </select>
                {/*{item.availableSelections} //un-comment for no dropdown option*/}
            </td>

            <div className={styles.textSection}>
                {[...Array(10).keys()].map(i => (
                    <input
                        key={i}
                        value={textValues[selectedOption] ? textValues[selectedOption][i] : ''}
                        onChange={e => handleTextChange(e, i)}
                        placeholder={`Enter text to display on line ${i + 1}`}
                        className={styles.selectionText}
                    />
                ))}
            </div>

            <td className={styles.validData}>
                {validData ?
                    <i className={styles.buttonImage} id={styles.validIcon}>
                        {circleCheck}
                    </i>
                    :
                    <i className={styles.buttonImage} id={styles.invalidIcon}>
                        {circleXmark}
                    </i>
                }
            </td>
        </tr>
    );
}

export default StaticField;